import SearchResultsListing from "@/components/organisms/search-results-listing";
import { appLocales, Locales } from "@/lib/i18n";
import { __ } from "@/lib/i18n/functions";
import { segments } from "@/locales/segment";
import { ProductDocument } from "@/prismicio-types";
import { Metadata } from "next";
import { notFound } from "next/navigation";

interface TemplateProps {
  resolution: Resolution;
  data?: object;
  generateMetadata?: (props: Resolution) => Promise<Metadata>;
}

interface Resolution {
  locale: Locales;
  templateName: string;
  Template: Template;
  slugs: string[];
  isArchive: boolean;
  isStatic: boolean;
  document?: ProductDocument<string>;
}

interface Template extends React.FC<TemplateProps> {
  generateMetadata?: (resolution: Resolution) => Promise<Metadata>;
}

const ResultsPage = ({ resolution }: TemplateProps) => {
  const locale = resolution.locale;
  let slugs = resolution.slugs;

  if (appLocales.locales.includes(slugs[0] as Locales)) {
    slugs = slugs.slice(1);
  }

  if (slugs.length > 2) {
    return notFound();
  }

  if (slugs.length === 1 && slugs[0] === segments[locale].search) {
    return (
      <div className="min-h-screen">
        <SearchResultsListing locale={locale} query="" />
      </div>
    );
  }

  if (slugs.length === 2 && slugs[0] === segments[locale].search) {
    const decodedQuery = decodeURIComponent(slugs[1].trim());

    return (
      <div className="min-h-screen">
        <SearchResultsListing locale={locale} query={decodedQuery} />
      </div>
    );
  }

  // Fallback: not a valid pattern
  return notFound();
};

export default ResultsPage;

ResultsPage.generateMetadata = async (resolution: Resolution) => {
  return {
    title: __("Search results", resolution.locale),
  };
};
